import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Radio } from "lucide-react";
import { api, fmtDate } from "@/lib/api";

const ROLE_CLS = { admin: "bg-[#D4AF37]", manufacturer: "bg-[#E06D3B]", customer: "bg-emerald-400" };

export function LiveActivity({ onOpenOrders }) {
  const [items, setItems] = useState([]);
  const seen = useRef(null);

  useEffect(() => {
    const load = () =>
      api.get("/activity").then((r) => {
        const fresh = seen.current ? r.data.filter((a) => !seen.current.has(a.entry.id)) : [];
        fresh.forEach((a) => toast(`${a.order_number} · ${a.entry.status}`, { description: `${a.entry.by_role}: ${a.entry.note || a.entry.by_name}` }));
        seen.current = new Set(r.data.map((a) => a.entry.id));
        setItems(r.data);
      }).catch(() => {});
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="rounded-sm border border-[#D4AF37]/15 bg-[#14110E] p-5" data-testid="live-activity">
      <div className="flex items-center justify-between mb-4">
        <p className="font-display text-lg flex items-center gap-2"><Radio className="h-4 w-4 text-[#E06D3B]" /> Live activity</p>
        <span className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-emerald-400"><span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" /> live</span>
      </div>
      {items.length === 0 && <p className="text-sm text-[#6E6558]">No activity yet. New orders and updates appear here instantly.</p>}
      <ul className="space-y-3 max-h-80 overflow-y-auto scrollbar-thin">
        {items.map((a) => (
          <li key={a.entry.id} className="flex gap-3 text-sm" data-testid={`activity-${a.entry.id}`}>
            <span className={`mt-1.5 h-2 w-2 rounded-full shrink-0 ${ROLE_CLS[a.entry.by_role]}`} />
            <button onClick={onOpenOrders} className="text-left min-w-0">
              <p><span className="font-display">{a.order_number}</span> <span className="text-[#D4AF37]">{a.entry.status}</span></p>
              <p className="text-xs text-[#6E6558] truncate">{a.entry.by_role} · {a.entry.note || a.entry.by_name} · {fmtDate(a.entry.at)}</p>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
